import { connect } from 'react-redux';

import addAbilityToOpenModal from '../../../../utilities/modalHOC';
import {
  createChapterActionSagas,
  createReferenceActionSagas,
  getUrlPdf,
} from '../../../Bibliographies/actionsSagas';
import {
  getChapters,
  getReferences,
  loadingGrid,
} from '../../../Bibliographies/selectors';
import { updateStudyProgramsOfReference } from '../../../Books/actionsSagas';
import { getUrlPdfPrivate } from '../../../Books/selectors';
import { getPermissions } from '../../../Login/selectors';
import {
  archiveActionSagas,
  changeStatusActionSagas,
  changeStatusChapterActionSagas,
  copyReferenceActionSagas,
  deleteAllQuestionsActionSagas,
  deleteChapterActionSagas,
  deletePdfActionSagas,
  deletePdfChapterActionSagas,
  deleteReferenceActionSagas,
  moveChapterSaga,
  removeManualRedQuestionsSagas,
  setManualRedQuestionsSagas,
  udpateReferenceActionSagas,
  updateChapterActionSagas,
} from '../../../References/actionsSagas';
import { loadQualReferences } from '../../actionsSagas';
import { getQuals, getSelectedQual } from '../../selectors';
import QualInformation from './QualInformation';

const mapStateToProps = (state, ownProps) => ({
  quals: getQuals(state),
  selectedQual: getSelectedQual(state),
  references: getReferences(state),
  chapters: getChapters(state),
  permissions: getPermissions(state),
  loading: loadingGrid(state),
  urlPdfPrivate: getUrlPdfPrivate(state),
});

const mapDispatchToProps = (dispatch) => ({
  createReference: (fields, qual) =>
    dispatch(createReferenceActionSagas(fields, qual, 'qual')),
  loadReferences: (id, archived) => dispatch(loadQualReferences(id, archived)),
  deleteReferencePdf: (reference) => dispatch(deletePdfActionSagas(reference)),
  changeReferenceStatus: (reference) =>
    dispatch(changeStatusActionSagas(reference)),
  updateReference: (fields, referenceId) => {
    dispatch(udpateReferenceActionSagas(fields, referenceId));
  },
  deleteReference: (reference) => {
    dispatch(deleteReferenceActionSagas(reference));
  },
  archiveReference: (reference, filter) => {
    dispatch(archiveActionSagas(reference, filter));
  },
  copyReference: (fields) => {
    fields.type = 'qual';
    dispatch(copyReferenceActionSagas(fields));
  },
  createChapter: (fields) => {
    dispatch(createChapterActionSagas(fields));
  },
  setManualRedQuestions: (chapter, reason) => {
    dispatch(setManualRedQuestionsSagas(chapter, reason));
  },
  removeManualRedQuestions: (chapter) => {
    dispatch(removeManualRedQuestionsSagas(chapter));
  },
  deletePdfChapter: (chapter) => {
    dispatch(deletePdfChapterActionSagas(chapter));
  },
  changeStatusChapter: (reference) => {
    dispatch(changeStatusChapterActionSagas(reference));
  },
  onMoveChapters: (chapter, other) => {
    dispatch(moveChapterSaga(chapter, other));
  },
  updateChapter: (fields, chapterId) => {
    dispatch(updateChapterActionSagas(fields, chapterId));
  },
  deleteAllQuestions: (chapter) => {
    dispatch(deleteAllQuestionsActionSagas(chapter));
  },
  deleteChapter: (reference, chapter, presentationIndex) => {
    dispatch(deleteChapterActionSagas(reference, chapter, presentationIndex));
  },
  associateRates: (studyPrograms, reference) => {
    dispatch(updateStudyProgramsOfReference(studyPrograms, reference));
  },
  getUrlPdf: (url) => {
    dispatch(getUrlPdf(url));
  },
});

const QualInformationContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(QualInformation);

export default addAbilityToOpenModal(QualInformationContainer);
